<!-- animation-timeline.component.html -->
<div class="tl-wrap">
  <div class="tl-head">
    <button class="tl-toggle" type="button" (click)="toggleOpen()" [attr.aria-expanded]="open">
      <span class="chev" aria-hidden="true">{{ open ? '▾' : '▸' }}</span>
      <span class="tl-title">Animation</span>
      <span class="count">{{ frames.length }} frame{{ frames.length === 1 ? '' : 's' }}</span>
    </button>
    <button class="tl-hide" type="button" *ngIf="canHide" (click)="hide.emit()"
            aria-label="Put the timeline away" title="Put the timeline away">✕</button>
  </div>

  <div class="tl-body" *ngIf="open">
    <div class="strip">
      <div *ngFor="let f of frames; let i = index"
           class="thumb" [class.active]="i===activeIndex" (click)="select(i)" title="Frame {{i+1}}">
        <img [src]="thumb(f)" alt="Frame {{i+1}}" />
        <span class="idx">{{ i+1 }}</span>
        <span class="dur">{{ f.ms }}ms</span>
      </div>
      <button class="add" type="button" (click)="addFrame()" title="Add a frame" aria-label="Add a frame">&#xFF0B;</button>
    </div>

    <div class="action-bar">
      <span class="sel">Frame {{ activeIndex + 1 }}</span>
      <button type="button" (click)="duplicateFrame(activeIndex)" title="Duplicate frame">&#x29C9; Copy</button>
      <button type="button" (click)="moveFrame(activeIndex,-1)" [disabled]="activeIndex===0" title="Move left">&#9664;</button>
      <button type="button" (click)="moveFrame(activeIndex,1)" [disabled]="activeIndex===frames.length-1" title="Move right">&#9654;</button>
      <button type="button" (click)="deleteFrame(activeIndex)" [disabled]="frames.length<=1" title="Delete frame">&#x2715;</button>
      <span class="ms-step">
        <button type="button" (click)="stepMs(-20)" title="Shorter">&minus;</button>
        <span class="ms-val">{{ frames[activeIndex].ms }} ms</span>
        <button type="button" (click)="stepMs(20)" title="Longer">&plus;</button>
      </span>
    </div>
  </div>
</div>
